export default function TransferEleviPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <p>
          <a
            href="/educatie/transferElevi/Raport transfer elevi.PDF"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            📄 Raport transfer elevi.PDF
          </a>
        </p>

      </main>
    </div>
  );
}